export const setContactFetchStatusAction = (status) => {
    return { type: 'CONTACT_SET_FETCH_STATUS_ACTION', payload: status }
}

export const setContactFetchResultsAction = (results) => {
    return { type: 'CONTACT_SET_FETCH_RESULTS_ACTION', payload: results }
}

export const setContactCurrentPageAction = (currentPage) => {
    return { type: 'CONTACT_SET_PAGINATION_CURRENT_PAGE', payload: currentPage }
}

export const setContactTotalPagesAction = (totalPages) => {
    return { type: 'CONTACT_SET_PAGINATION_TOTAL_PAGES', payload: totalPages }
}

export const setContactRowsAction = (rowCount) => {
    return { type: 'CONTACT_SET_PAGINATION_ROWS', payload: rowCount }
}

export const setContactFirstAction = (first) => {
    return { type: 'CONTACT_SET_PAGINATION_FIRST', payload: first }
}

export const setContactFilterAction = (filter) => {
    return { type: 'CONTACT_SET_FILTER', payload: filter }
}

export const setContactSortAction = (sort) => {
    return { type: 'CONTACT_SET_SORT', payload: sort }
}

export const setContactRefreshAction = (refresh) => {
    return { type: 'CONTACT_SET_REFRESH', payload: refresh }
}

export const setContactExcelExportAction = () => {
    return { type: 'CONTACT_SET_EXPORT_EXCEL' }
}

// Contact Works Actions - now with contactId for independent table instances
export const setContactWorksFetchStatusAction = (contactId, status) => {
    return { type: 'CONTACT_WORKS_SET_FETCH_STATUS_ACTION', payload: { contactId, status } }
}

export const setContactWorksFetchResultsAction = (contactId, results) => {
    return { type: 'CONTACT_WORKS_SET_FETCH_RESULTS_ACTION', payload: { contactId, results } }
}

export const setContactWorksRefreshAction = (contactId, refresh) => {
    return { type: 'CONTACT_WORKS_SET_REFRESH', payload: { contactId, refresh } }
}

export const setContactWorksCurrentPageAction = (contactId, currentPage) => {
    return { type: 'CONTACT_WORKS_SET_PAGINATION_CURRENT_PAGE', payload: { contactId, currentPage } }
}

export const setContactWorksTotalPagesAction = (contactId, totalPages) => {
    return { type: 'CONTACT_WORKS_SET_PAGINATION_TOTAL_PAGES', payload: { contactId, totalPages } }
}

export const setContactWorksRowsAction = (contactId, rowCount) => {
    return { type: 'CONTACT_WORKS_SET_PAGINATION_ROWS', payload: { contactId, row: rowCount } }
}

export const setContactWorksFirstAction = (contactId, first) => {
    return { type: 'CONTACT_WORKS_SET_PAGINATION_FIRST', payload: { contactId, first } }
}

export const setContactWorksFilterAction = (contactId, filter) => {
    return { type: 'CONTACT_WORKS_SET_FILTER', payload: { contactId, filter } }
}

export const setContactWorksSortAction = (contactId, sort) => {
    return { type: 'CONTACT_WORKS_SET_SORT', payload: { contactId, sort } }
}

export const initContactWorksAction = (contactId) => {
    return { type: 'CONTACT_WORKS_INIT_CONTACT', payload: { contactId } }
}

